// extracted by mini-css-extract-plugin
export var body = "vr1ft";
export var content = "_0oS7b";
export var image = "VyvoP";
export var main = "YQDJX";
export var title = "xOIAz";